var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElectriccar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1355_551)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 20,
    r: 13,
    fill: "#F2F2F2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3375 14.0094L18.2375 17.15C17.5125 17.45 17 18.1656 17 19V23.5V25C17 25.5531 17.4469 26 18 26H19C19.5531 26 20 25.5531 20 25V23.5H30V25C30 25.5531 30.4469 26 31 26H32C32.5531 26 33 25.5531 33 25V23.5V19C33 18.1656 32.4875 17.45 31.7625 17.15L30.6625 14.0094C30.2406 12.8063 29.1063 12 27.8313 12H22.1687C20.8937 12 19.7594 12.8063 19.3375 14.0094V14.0094ZM20 21C19.4469 21 19 20.5531 19 20C19 19.4469 19.4469 19 20 19C20.5531 19 21 19.4469 21 20C21 20.5531 20.5531 21 20 21ZM31 20C31 20.5531 30.5531 21 30 21C29.4469 21 29 20.5531 29 20C29 19.4469 29.4469 19 30 19C30.5531 19 31 19.4469 31 20ZM26.9469 14.725L25.8094 17H27.5C27.7156 17 27.9063 17.1375 27.975 17.3406C28.0438 17.5437 27.9719 17.7688 27.8 17.9L23.8 20.9C23.6156 21.0406 23.3562 21.0312 23.1781 20.8844C23 20.7375 22.9469 20.4844 23.05 20.2781L24.1906 18H22.5C22.2844 18 22.0938 17.8625 22.025 17.6594C21.9563 17.4563 22.0281 17.2312 22.2 17.1L26.2 14.1C26.3844 13.9594 26.6437 13.9687 26.8219 14.1156C27 14.2625 27.0531 14.5156 26.95 14.7219L26.9469 14.725Z",
    fill: "#132439"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1355_551",
    x: 12,
    y: 7,
    width: 26,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1355_551"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectriccar);
export default __webpack_public_path__ + "static/media/electriccar.75f54bf834408ca4955cbac49638d24f.svg";
export { ForwardRef as ReactComponent };